var initialsLength = 2;
/**
 * Gets initials from account info.
 * Tries to get those from either `idTokenClaims` or `name` or `username`.
 * @param account Account info to get initials from.
 */
export var getInitialsFromAccount = function (account) {
    var idTokenClaims = account.idTokenClaims, name = account.name, username = account.username;
    // Try to get initials from token claims
    if (idTokenClaims) {
        var _a = idTokenClaims, given_name = _a.given_name, family_name = _a.family_name;
        if (given_name && family_name) {
            return "" + given_name[0] + family_name[0];
        }
        if (given_name) {
            return given_name.slice(0, initialsLength);
        }
        if (family_name) {
            return family_name.slice(0, initialsLength);
        }
    }
    // Try to get initials from account name
    if (name) {
        return name.slice(0, initialsLength);
    }
    // Try to get initials from account username
    if (username) {
        return username.slice(0, initialsLength);
    }
    return '';
};
